import { getMediaQuery } from '../../helpers/responsive-helpers';
import breakpoints from './breakpoints';
var mediaQuery = {
    small: getMediaQuery(breakpoints.small),
    medium: getMediaQuery(breakpoints.medium),
    large: getMediaQuery(breakpoints.large),
};
export default mediaQuery;
